import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { useAppSelector } from '../../hooks';
import { CreateOrAddToBatchButton } from './CreateOrAddToBatchButton';
import { CreateOrAddToBundleButton } from './CreateOrAddToBundleButton';
import { FilterToBundlesWithWarningsButton } from './FilterToBundlesWithWarningsButton';

export function BatchAndBundleButtonBar() {
  const creatingBatchesOrBundles = useAppSelector((state) => state.batchesAndBundlesTab.activeList);
  let buttonBar: ReactNode;
  switch (creatingBatchesOrBundles) {
    case 'batches':
      buttonBar = <CreateOrAddToBatchButton />;
      break;
    case 'bundles':
      buttonBar = (
        <>
          <CreateOrAddToBundleButton />
          <FilterToBundlesWithWarningsButton />
        </>
      );
      break;
    default:
      assertExhaustiveSwitch(creatingBatchesOrBundles);
  }

  return <Box sx={{ display: 'flex', flexDirection: 'row' }}>{buttonBar}</Box>;
}
